
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const DemographicEmptyState = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Demographic Analysis</CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-muted-foreground text-center py-4">
          No demographic data available for this poll
        </p>
      </CardContent>
    </Card>
  );
};

export default DemographicEmptyState;
